export const QoSstrs = [
    "0: at most once",
    "1: at least once",
    "2: exactly once"
]